// @ts-nocheck
import { MODULE_ACL, USER_ROLES } from './constant';
import { parseModuleOperations } from './voicePlanAcl';

export const COMPANY_ACL_MODULE = MODULE_ACL.COMPANY;
export const CHANGE_ASSETS_VISIBILITY = 'change_assets_visibility';

/** Asset types the toggle offers. Mirrors company-asset-container.js. */
export const ASSET_TYPES = ['reports', 'recordings'];

export const ASSET_TYPE_LABEL = {
  reports: 'Reports',
  recordings: 'Recordings & Voicemails',
};

function isSuperAdminRole(userRole, isSuperAdmin) {
  return Boolean(isSuperAdmin) || userRole === USER_ROLES.SUPERADMIN;
}

export function getCompanyAclEntry(moduleOperations) {
  const ops = parseModuleOperations(moduleOperations);
  return ops[COMPANY_ACL_MODULE] || null;
}

export function normalizeCompanyEditOptions(options) {
  if (!Array.isArray(options)) return [];
  return [
    ...new Set(
      options
        .map((option) => String(option).trim().toLowerCase())
        .filter((option) => option === CHANGE_ASSETS_VISIBILITY),
    ),
  ];
}

export function hasCompanyAssetsVisibilityAcl(moduleOperations) {
  const entry = getCompanyAclEntry(moduleOperations);
  if (!entry?.read || !entry?.edit) return false;
  return normalizeCompanyEditOptions(entry.edit_options).includes(
    CHANGE_ASSETS_VISIBILITY,
  );
}

/** The two flags off `user.assignedCompany`, defaulting to "not allowed". */
export function isAssetsVisibilityGrantableCompany(
  assignedCompany,
  hasCallCentreAdminChild = false,
) {
  if (hasCallCentreAdminChild === true) return true;
  if (!assignedCompany) return false;
  if (assignedCompany.is_own_company === true) return true;
  return assignedCompany.is_reseller_company === false;
}

const EXCLUDED_ROLES = [
  USER_ROLES.CALL_CENTRE_ADMIN,
  USER_ROLES.CALL_CENTRE_TEAM_LEAD,
  USER_ROLES.CALL_CENTRE_AGENT,
];

export function getParentGrantableAssetsVisibility(
  moduleOperations,
  { isSuperAdmin = false, userRole = null } = {},
) {
  if (isSuperAdminRole(userRole, isSuperAdmin)) {
    return { canGrantAssetsVisibility: true };
  }

  if (EXCLUDED_ROLES.includes(userRole)) {
    return { canGrantAssetsVisibility: false };
  }

  return {
    canGrantAssetsVisibility: hasCompanyAssetsVisibilityAcl(moduleOperations),
  };
}

export function normalizeCompanyAssetsVisibilityAclForSave(
  { edit_options = [] } = {},
  parentGrantable = null,
) {
  let options = normalizeCompanyEditOptions(edit_options);
  if (parentGrantable && !parentGrantable.canGrantAssetsVisibility) {
    options = [];
  }
  return { edit_options: options };
}

export function formatCompanyAssetsVisibilityAclLabel(moduleEntry) {
  const options = normalizeCompanyEditOptions(moduleEntry?.edit_options);
  return options.includes(CHANGE_ASSETS_VISIBILITY) ? 'Assets Visibility' : '—';
}

export function canChangeCompanyAssetsVisibility(
  companyRow,
  {
    userId = null,
    userRole = null,
    isSuperAdmin = false,
    moduleOperations = null,
    assignedCompany = null,
    hasCallCentreAdminChild = false,
  } = {},
) {
  if (!companyRow || companyRow.is_deleted === true) return false;

  const actorId = Number(userId);
  if (!Number.isFinite(actorId) || actorId <= 0) return false;

  const createdBy = Number(
    companyRow.created_by?.id ?? companyRow.created_by_id ?? companyRow.created_by,
  );
  if (!Number.isFinite(createdBy) || createdBy !== actorId) return false;

  if (isSuperAdminRole(userRole, isSuperAdmin)) return true;

  if (!hasCompanyAssetsVisibilityAcl(moduleOperations)) return false;
  return isAssetsVisibilityGrantableCompany(assignedCompany, hasCallCentreAdminChild);
}
